module.exports = "/images/logo_beecrm_dark.png?12454f1776c28b119a29ff71dcdc5607";